import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import _ from "lodash";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Form,
  InputGroup,
  Nav,
  OverlayTrigger,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import ReactDOMServer from "react-dom/server";
import { AiOutlineFile } from "react-icons/ai";
import { BiSolidPrinter } from "react-icons/bi";
import { BsBagCheckFill, BsCameraVideoFill, BsGoogle } from "react-icons/bs";
import { FaCloudUploadAlt } from "react-icons/fa";
import { ImDownload2 } from "react-icons/im";
import {
  RiBuilding2Fill,
  RiDownload2Fill,
  RiFileListFill,
} from "react-icons/ri";
import { VscSend } from "react-icons/vsc";
import Loader from "react-js-loader";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { useParams } from "react-router-dom";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { solarizedlight } from "react-syntax-highlighter/dist/esm/styles/prism";
import {
  API_URL,
  BANDWIDTH_ISSUE_CANDIDATE_END,
  BANDWIDTH_ISSUE_INTERVIEWER_END,
  HARDWARE_ISSUE_CANDIDATE_END,
  HARDWARE_ISSUE_INTERVIEWER_END,
  INTERVIEW_FINAL_STATUS_REJECTED,
  INTERVIEW_FINAL_STATUS_SELECTED,
  NO_SHOW_BY_CANDIDATE,
  NO_SHOW_BY_INTERVIWER,
  PROXY,
  commonDateFormat,
  dayDifference,
  getAuthUserFromSessionStorage,
} from "../../common/constant";
import HeaderScreen from "../HeaderScreen/HeaderScreen";
import "./LiveInterviewerScreen.css";
import { EmbedPDF } from "@simplepdf/react-embed-pdf";
import { SUB_ADMIN, SUPER_ADMIN } from "../../common/roles";
import moment from "moment";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const StarRating = ({ totalStars, filledStars, onRatingChange }) => {
  const handleClick = (starValue) => {
    // setRating(starValue);
    // onRatingChange(starValue);
    onRatingChange(starValue);
  };

  return (
    <div>
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1;
        return (
          <span
            className="cursor-pointer"
            key={index}
            style={{
              color: starValue <= filledStars ? "gold" : "grey",
              fontSize: "2em",
            }}
            onClick={() => handleClick(starValue)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

const SELECTED_CHAR_LIMIT = 250;
const REJECTED_CHAR_LIMIT = 100;

//Skill Limits
const SKILL_MIN_LENGTH = 100;
const SKILL_MAX_LENGTH = 800;

//Final Feedback Limits
const FINAL_FEEDBACK_MIN_LENGTH = 200;
const FINAL_FEEDBACK_MAX_LENGTH = 1200;

const LiveInterviewerScreen = () => {
  const params = useParams();

  const getUserRole = () => {
    const roleName = JSON.parse(localStorage.getItem('rememberMeData'))
    // console.log("roleName", roleName?.userType);
    return roleName?.userType || "";
  }
  const [userDetails, setUserDetails] = useState(
    getAuthUserFromSessionStorage()
  );
  const [interviewStatus, setInterviewStatus] = useState("All");
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [jobDetails, setJobDetails] = useState({});
  const [interviewState, setInterviewState] = useState(null);
  const [interviewDetail, setInterviewDetail] = useState({});
  const fileInputRef = useRef(null);
  const profilePicInputRef = useRef(null);
  const [codeContent, setcodeContent] = useState("");
  const [questionContent, setQuestionContent] = useState("");
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const feedbackSheetInputRef = useRef(null);
  const [hasSelectedFile, setHasSelectedFile] = useState(false);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    if (!_.isUndefined(params.id) && !_.isNull(params.id) && params.id !== "") {
      getInterviewDetails(params.id);
      getUserRole()
    }
  }, [params.id]);

  useEffect(() => {
    if (interviewState && !interviewDetail.primary_skill_feedback && !interviewDetail.secondary_skill_feedback) {
      setInterviewDetail(prev => {
        const primarySkillFeedback = interviewState.primary_skill_feedback || [];
        const secondarySkillFeedback = interviewState.secondary_skill_feedback || [];

        const initializedPrimaryFeedback = primarySkillFeedback.map(item => {
          if (typeof item === 'string') {
            return { review: item, rating: 0 };
          }
          return item || { review: "", rating: 0 };
        });

        const initializedSecondaryFeedback = secondarySkillFeedback.map(item => {
          if (typeof item === 'string') {
            return { review: item, rating: 0 };
          }
          return item || { review: "", rating: 0 };
        });

        return {
          ...prev,
          primary_skill_feedback: initializedPrimaryFeedback,
          secondary_skill_feedback: initializedSecondaryFeedback
        };
      });
    }
  }, [interviewState]);

  const getInterviewDetails = (id) => {
    setIsLoading(true);
    fetch(`${API_URL}api/getInterview/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${userDetails.token}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          !_.isUndefined(response) &&
          !_.isNull(response) &&
          !_.isUndefined(response.data) &&
          !_.isNull(response.data) &&
          !_.isEmpty(response.data)
        ) {
          setInterviewState(response.data);
          var primarySkillFeedback = response.data.primary_skill_feedback ?? [];
          for (var k = 0; k < primarySkillFeedback.length; k++) {
            if (primarySkillFeedback[k] === null) {
              primarySkillFeedback[k] = { rating: 0, review: "" };
            }
          }

          var secondarySkillFeedback =
            response.data.secondary_skill_feedback ?? [];
          for (var k = 0; k < secondarySkillFeedback.length; k++) {
            if (secondarySkillFeedback[k] === null) {
              secondarySkillFeedback[k] = { rating: 0, review: "" };
            }
          }

          setInterviewDetail({
            incomplete_interview: response.data.incomplete_interview,
            overall_rating: response.data.overall_rating,
            final_status: response.data.final_status,
            feedback_sheet: response.data.feedback_sheet,
            coding_questions: response.data.coding_questions,
            code_of_screenshot: response.data.code_of_screenshot ?? [],
            is_feedback_given: response.data.is_feedback_given,
            google_meet_id: response.data.google_meet_id,
            primary_skill_feedback: primarySkillFeedback,
            secondary_skill_feedback: secondarySkillFeedback,
            good_to_have_skill_feedback:
              response.data.good_to_have_skill_feedback ?? [],
            coding_skill_feedback: response.data.coding_skill_feedback ?? [],
            final_recommendation: response.data.final_recommendation ?? "",
            good_to_have_skill_feedback_rating:
              response.data.good_to_have_skill_feedback_rating ?? "",
            coding_skill_feedback_rating:
              response.data.coding_skill_feedback_rating ?? 0,
            professional_skill: response.data.professional_skill
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setInterviewState({});
        setIsLoading(false);
      });
  };

  useEffect(() => {
    //Implementing the setInterval method
    const interval = setInterval(() => {
      const id = params.id;
      fetch(`${API_URL}api/getInterview/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (
            !_.isUndefined(response) &&
            !_.isNull(response) &&
            !_.isUndefined(response.data) &&
            !_.isNull(response.data) &&
            !_.isEmpty(response.data)
          ) {
            if (interviewState) {
              if (
                interviewState.code_by_candidate === "" ||
                interviewState.code_by_candidate !=
                response.data.code_by_candidate
              ) {
                setInterviewState({
                  ...interviewState,
                  code_by_candidate: response.data.code_by_candidate,
                });
              }
            }
          }
        })
        .catch((err) => { });
    }, 5000);

    return () => clearInterval(interval);
  }, [interviewState]);

  // save on change

  const handleDownload = (fileUrl) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = new URL(fileUrl).pathname
          .split("/")
          .pop()
          ?.replaceAll("%20", " ");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Error downloading PDF:", error));
  };

  const printPDF = (fileUrl) => {
    const newWindow = window.open("", "_blank");
    const pdfContent = ReactDOMServer.renderToString(
      <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            renderAnnotationLayer={false}
          />
        ))}
      </Document>
    );
    newWindow.document.write(
      `<html><head><title>Print</title></head><body>${pdfContent}</body></html>`
    );
    newWindow.document.close();
    newWindow.print();
  };

  const validateForm = () => { };

  const updateCandidateProfile = (message = "", isShowToast = true) => {
    if (isShowToast) {
      setIsLoading(true);
    }
    fetch(`${API_URL}api/updateCandidateProfileData/${params.id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails.token}`,
      },
      body: JSON.stringify(interviewDetail),
    })
      .then((response) => response.json())
      .then((response) => {
        if (isShowToast) {
          if (message == "") {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: response.message,
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: message,
              life: 3000,
            });
          }
          getInterviewDetails(params.id);
        }
      })
      .catch((error) => {
        if (isShowToast) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong",
            life: 3000,
          });
        }
      })
      .finally((e) => {
        if (isShowToast) {
          setIsLoading(false);
        }
      });
  };

  const handleFileChange = (event, name) => {
    const selectedFile = event.target.files[0];
    uploadFile(selectedFile, name);
  };

  const uploadFile = (selectedFile, name) => {
    const data = new FormData();
    data.append("file", selectedFile);
    fetch(`${API_URL}api/uploadFiles`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((response) => {
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        if (name === "code_of_screenshot") {
          const codeOfScreenshot = interviewDetail.code_of_screenshot ?? [];
          codeOfScreenshot.push(response.filepath);
          setInterviewDetail({
            ...interviewDetail,
            code_of_screenshot: codeOfScreenshot,
          });
        } else {
          setInterviewDetail({
            ...interviewDetail,
            [name]: response.filepath,
          });
        }
      })
      .catch((error) => {
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Something went wrong",
          life: 3000,
        });
      });
  };

  const checkFeedbackGiven = () => {
    if (interviewDetail.incomplete_interview !== "") {
      return true;
    } else {
      if (interviewDetail.feedback_sheet !== "") {
        return true;
      } else {
        return isFormValuesValid();
      }
    }
  };

  const [activeTabKey, setActiveTabKey] = useState("primarySkillFeedback");

  const isFormValuesValid = () => {
    let missingFields = [];

    // Upload Screenshot Validation
    if (!interviewDetail.code_of_screenshot || interviewDetail.code_of_screenshot.length === 0) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "screenshots is mandatory.",
        life: 4000,
      });
      return false;
    }


    const primaryMin = SKILL_MIN_LENGTH;
    const secondaryMin = SKILL_MIN_LENGTH;
    const overallMin = FINAL_FEEDBACK_MIN_LENGTH;

    // Primary Skills Validation
    for (let index = 0; index < interviewState.job.primary_skill.length; index++) {
      const feedback = interviewDetail.primary_skill_feedback[index];
      if (
        !feedback ||
        !feedback.rating ||
        !feedback.review ||
        feedback.review.replace(/<[^>]*>/g, "").length < primaryMin
      ) {
        missingFields.push("Primary skills");
        break;
      }
    }

    // Secondary Skills Validation
    for (let index = 0; index < interviewState.job.secondary_skill.length; index++) {
      const feedback = interviewDetail.secondary_skill_feedback[index];
      if (
        !feedback ||
        !feedback.rating ||
        !feedback.review ||
        feedback.review.replace(/<[^>]*>/g, "").length < secondaryMin
      ) {
        missingFields.push("Secondary skills");
        break;
      }
    }

    // Overall Feedback Validation
    if (
      !interviewDetail.overall_rating ||
      !interviewDetail.final_recommendation ||
      interviewDetail.final_recommendation.replace(/<[^>]*>/g, "").length < overallMin
    ) {
      missingFields.push("Overall Feedback");
    }

    if (missingFields.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: `${missingFields.join(", ")} are mandatory fields. Please fill all mandatory fields before submitting.`,
        life: 4000,
      });
      return false;
    }

    // Good to Have Skills (optional, but if one is filled, both required)
    const goodToHaveFeedback = interviewDetail.good_to_have_skill_feedback?.replace(/<[^>]*>/g, "").trim();
    const goodToHaveRating = interviewDetail.good_to_have_skill_feedback_rating;

    if (
      (goodToHaveFeedback && goodToHaveFeedback.length > 0 && (!goodToHaveRating || goodToHaveFeedback.length < 50)) ||
      (goodToHaveRating && (!goodToHaveFeedback || goodToHaveFeedback.length < 50))
    ) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "If you provide Good to have skills feedback, at least 50 characters and a rating are required.",
        life: 3000,
      });
      return false;
    }

    // Coding Skills (optional, but if one is filled, both required)
    const codingFeedback = interviewDetail.coding_skill_feedback?.replace(/<[^>]*>/g, "").trim();
    const codingRating = interviewDetail.coding_skill_feedback_rating;

    if (
      (codingFeedback && codingFeedback.length > 0 && (!codingRating || codingFeedback.length < 50)) ||
      (codingRating && (!codingFeedback || codingFeedback.length < 50))
    ) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "If you provide Coding skills feedback, at least 50 characters and a rating are required.",
        life: 3000,
      });
      return false;
    }

    // Professional Skills (optional, but if enabled, both required)
    for (let key in interviewDetail.professional_skill) {
      const item = interviewDetail.professional_skill[key];
      if (item.enable) {
        const feedbackLength = item.feedback ? item.feedback.replace(/<[^>]*>/g, "").trim().length : 0;
        if ((feedbackLength > 0 && (!item.rating || feedbackLength < 50)) ||
          (item.rating && feedbackLength < 50)) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: `If you provide feedback for ${item.label}, at least 50 characters and a rating are required!`,
            life: 3000
          });
          return false;
        }
      }
    }

    // Final Status Validation
    if (!interviewDetail.final_status) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please provide your final status to proceed with the submission.",
        life: 3000,
      });
      return false;
    }

    return true;
  };

  const isNotEditable = () => {
    if ([SUPER_ADMIN, SUB_ADMIN].includes(getUserRole())) return false
    const isEditable = moment(interviewState.record_editable_till).isAfter(moment());
    return isEditable ? false : true
    // return !(dayDifference(interviewState.scheduled_on) <= 1 || (interviewState.is_super_admin_given_edit_permission && dayDifference(interviewState.super_admin_given_edit_permission_date) <= 1));
  };

  const getCharCount = (content) => {
    if (!content) return 0;
    return String(content)?.replace(/<[^>]*>/g, '').length;
  };

  const getRemainingChars = (content, fieldName) => {
    const limit = interviewDetail.final_status === INTERVIEW_FINAL_STATUS_SELECTED ? SELECTED_CHAR_LIMIT : REJECTED_CHAR_LIMIT;
    return limit - getCharCount(content);
  };

  const enforceMaxLength = (data, maxLength) => {
    if (!data) return data;

    const plainText = data.replace(/<[^>]*>/g, "");

    if (plainText.length > maxLength){
      return plainText.substring(0, maxLength)
      }

      return data;
  };
  
  
  const handleEditorChange = (event, editor, fieldName) => {
  let data = editor.getData();

  if (fieldName === "final_recommendation") {
    data = enforceMaxLength(
      data,
      FINAL_FEEDBACK_MAX_LENGTH
    );
  } else {
    data = enforceMaxLength(
      data,
      SKILL_MAX_LENGTH
    );
  }
    // Remove all max character limit logic for good to have skills, coding skills, and professional skills
    // Only update the state based on the field name
    if (fieldName.includes('professional_skill')) {
      const [_, key, field] = fieldName.split('.');
      const updatedProfessionalSkill = {
        ...interviewDetail.professional_skill,
        [key]: {
          ...interviewDetail.professional_skill[key],
          [field]: data
        }
      };
      setInterviewDetail(prev => ({
        ...prev,
        professional_skill: updatedProfessionalSkill
      }));
    } else {
      setInterviewDetail(prev => ({
        ...prev,
        [fieldName]: data
      }));
    }

    // Debounce the profile update
    const timeoutId = setTimeout(() => {
      updateCandidateProfile("", false);
    }, 500);

    return () => clearTimeout(timeoutId);
  };

  // Add this function to handle checkbox changes
  const handleProfessionalSkillCheckbox = (e, key) => {
    const checked = e.target.checked;

    // Create a new professional_skill object
    const updatedProfessionalSkill = {
      ...interviewDetail.professional_skill,
      [key]: {
        ...interviewDetail.professional_skill[key],
        enable: checked,
        // Clear feedback and rating when unchecked
        feedback: checked ? interviewDetail.professional_skill[key].feedback : "",
        rating: checked ? interviewDetail.professional_skill[key].rating : 0
      }
    };

    setInterviewDetail({
      ...interviewDetail,
      professional_skill: updatedProfessionalSkill
    });
    updateCandidateProfile("", false);
  };

  // Add this helper function to safely trim content
  const safelyTrimContent = (content, limit) => {
    if (!content || typeof content !== 'string') return '';
    return content.substring(0, limit);
  };

  // Modified handleFinalStatusChange function
  const handleFinalStatusChange = (e) => {
    const newStatus = e.target.value;
    const oldStatus = interviewDetail.final_status;
    const newLimit = newStatus === INTERVIEW_FINAL_STATUS_SELECTED ? SELECTED_CHAR_LIMIT : REJECTED_CHAR_LIMIT;

    // Create a new interviewDetail object with the new status
    const updatedDetail = {
      ...interviewDetail,
      final_status: newStatus
    };

    // Only trim content if switching from Selected to Rejected
    if (oldStatus === INTERVIEW_FINAL_STATUS_SELECTED && newStatus === INTERVIEW_FINAL_STATUS_REJECTED) {
      // Trim primary skills feedback
      if (updatedDetail.primary_skill_feedback) {
        updatedDetail.primary_skill_feedback = updatedDetail.primary_skill_feedback.map(feedback => ({
          ...feedback,
          review: feedback.review ? feedback.review.substring(0, REJECTED_CHAR_LIMIT) : ""
        }));
      }

      // Trim secondary skills feedback
      if (updatedDetail.secondary_skill_feedback) {
        updatedDetail.secondary_skill_feedback = updatedDetail.secondary_skill_feedback.map(feedback => ({
          ...feedback,
          review: feedback.review ? feedback.review.substring(0, REJECTED_CHAR_LIMIT) : ""
        }));
      }

      // Trim good to have skills feedback
      if (updatedDetail.good_to_have_skill_feedback) {
        updatedDetail.good_to_have_skill_feedback = updatedDetail.good_to_have_skill_feedback.substring(0, REJECTED_CHAR_LIMIT);
      }

      // Trim coding skills feedback
      if (updatedDetail.coding_skill_feedback) {
        updatedDetail.coding_skill_feedback = updatedDetail.coding_skill_feedback.substring(0, REJECTED_CHAR_LIMIT);
      }

      // Trim final recommendation
      if (updatedDetail.final_recommendation) {
        updatedDetail.final_recommendation = updatedDetail.final_recommendation.substring(0, REJECTED_CHAR_LIMIT);
      }

      // Trim professional skills feedback
      if (updatedDetail.professional_skill) {
        const updatedProfessionalSkill = { ...updatedDetail.professional_skill };
        Object.keys(updatedProfessionalSkill).forEach(key => {
          if (updatedProfessionalSkill[key] && updatedProfessionalSkill[key].feedback) {
            updatedProfessionalSkill[key] = {
              ...updatedProfessionalSkill[key],
              feedback: updatedProfessionalSkill[key].feedback.substring(0, REJECTED_CHAR_LIMIT)
            };
          }
        });
        updatedDetail.professional_skill = updatedProfessionalSkill;
      }
    }

    // Update state once with all changes
    setInterviewDetail(updatedDetail);

    // Update profile after state is updated
    setTimeout(() => {
      updateCandidateProfile("", false);
    }, 0);
  };

  const getOverallFeedbackRemainingChars = (content) => {
    const minLength = FINAL_FEEDBACK_MIN_LENGTH;
    const currentLength = content ? content.replace(/<[^>]*>/g, '').length : 0;
    return Math.max(minLength - currentLength, 0);
  };

  // Helper function
  const getMinLengthRemaining = (content, min) => {
    const currentLength = content ? content.replace(/<[^>]*>/g, '').length : 0;
    return Math.max(min - currentLength, 0);
  };

  // handle profile picture file change
  const handleProfilePictureFileChange = (event, name) => {
    const selectedFile = event.target.files[0];
    console.log("selectedFile===>", selectedFile);
    if (selectedFile) {
      setIsLoading(true);
      const data = new FormData();
      data.append("json", JSON.stringify({
        id: params.id,
        old_path: interviewState.candidate_pic || ""
      }));
      data.append("file", selectedFile);
      fetch(`${API_URL}api/uploadCandidatePic`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
        },
        body: data,
      })
        .then(response => response.json())
        .then(data => {
          console.log("handleProfilePictureFileChange data===>", data);
          // Reset file input first
          if (profilePicInputRef.current) {
            profilePicInputRef.current.value = "";
          }
          // Check if upload was successful before refetching
          if (data && !data.error) {
            // Refetch interview details to get updated profile picture from API
            // getInterviewDetails will manage its own loading state
            getInterviewDetails(params.id);
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: data.message || "Profile picture updated successfully",
              life: 3000,
            });
          } else {
            setIsLoading(false);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: data.message || "Failed to update profile picture. Please try again.",
              life: 3000,
            });
          }
        })
        .catch(error => {
          console.error("Error===>", error);
          setIsLoading(false);
          // Reset file input on error
          if (profilePicInputRef.current) {
            profilePicInputRef.current.value = "";
          }
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to update profile picture. Please try again.",
            life: 3000,
          });
        });
    }
  };

  // Define min lengths for use in both validation and UI
  const primaryMin = SKILL_MIN_LENGTH;
  const secondaryMin = SKILL_MIN_LENGTH;
  const overallMin = FINAL_FEEDBACK_MIN_LENGTH;

  return (
    <div className="container-fluid live-interviewer-container fixed-padding-2">
      <Toast ref={toast} />
      {isLoading && (
        <div className="spinner-loader">
          <Loader
            type="spinner-circle"
            bgColor="#2F2F74"
            color="#2F2F74"
            size={100}
          />
        </div>
      )}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(event) => {
          handleFileChange(event);
        }}
      />
      <div className="row">
        <div className="col-12 px-0">
          <HeaderScreen />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <Tab.Container defaultActiveKey="liveinterview">
            <div className="row live-interviewer-container-tab">
              <div className="col-1 sec-menu">
                <Nav className="flex-column">
                  <Nav.Item>
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip>Live Interview</Tooltip>}
                    >
                      <Nav.Link eventKey="liveinterview">
                        <BsCameraVideoFill size={24} />
                      </Nav.Link>
                    </OverlayTrigger>
                  </Nav.Item>
                  <Nav.Item>
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip>Resume</Tooltip>}
                    >
                      <Nav.Link eventKey="resume">
                        <RiFileListFill size={24} />
                      </Nav.Link>
                    </OverlayTrigger>
                  </Nav.Item>
                  <Nav.Item>
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip>Job Responsibilities</Tooltip>}
                    >
                      <Nav.Link eventKey="jobresponsibilities">
                        <BsBagCheckFill size={24} />
                      </Nav.Link>
                    </OverlayTrigger>
                  </Nav.Item>
                  <Nav.Item>
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip>About Company</Tooltip>}
                    >
                      <Nav.Link eventKey="aboutcompany">
                        <RiBuilding2Fill size={24} />
                      </Nav.Link>
                    </OverlayTrigger>
                  </Nav.Item>
                </Nav>
              </div>
              {interviewState && (
                <div className="col-12 sec-menu-padding">
                  <Card className="live-interviewer-details-card">
                    <Card.Body className="p-3">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-3 col-xxl-2 col-xxxl-2 live-interviewer-details-col">
                          <div className="profile-image-container d-flex flex-column justify-content-center align-items-center gap-2">
                            <img src={interviewState?.candidate_pic ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.candidate_pic}` : "/profile_pic.png"} alt="Profile" width="100px" height="100px" className="rounded-circle" />
                            {/* edit icon */}
                            {interviewState?.candidate_pic ? <label type="button" className="btn btn-warning" onClick={() => profilePicInputRef.current.click()}>Update Profile Picture</label> : <label type="button" className="btn btn-primary" onClick={() => profilePicInputRef.current.click()}>Upload Profile Picture</label>}
                            <input type="file" ref={profilePicInputRef} style={{ display: "none" }} onChange={(event) => {
                              handleProfilePictureFileChange(event, "file");
                            }} />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3 col-xxxl-3 live-interviewer-details-col">
                          <p className="live-interviewer-details-card-title">
                            Candidate Name
                          </p>
                          <p className="live-interviewer-details-card-title-samll">
                            {interviewState
                              ? interviewState.candidate_name
                              : ""}
                          </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-2 col-xxl-2 col-xxxl-2 live-interviewer-details-col">
                          <p className="live-interviewer-details-card-title">
                            Job Title
                          </p>
                          <p className="live-interviewer-details-card-title-samll">
                            {interviewState
                              ? interviewState.job
                                ? interviewState.job.job_title
                                : ""
                              : ""}
                          </p>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-2 col-xxl-2 col-xxxl-2 live-interviewer-details-col">
                          <p className="live-interviewer-details-card-title">
                            Company Name
                          </p>
                          <p className="live-interviewer-details-card-title-samll">
                            {interviewState ? interviewState.company_name : ""}
                          </p>
                        </div>

                        <div className="col-12 col-md-12 col-lg-12 col-xl-2 col-xxl-3 col-xxxl-3 live-interviewer-details-col">
                          <p className="live-interviewer-details-card-title">
                            Coordinator
                          </p>
                          <p className="live-interviewer-details-card-title-samll">
                            {interviewState && interviewState.coordinator
                              ? interviewState.coordinator.first_name +
                              " " +
                              interviewState.coordinator.last_name
                              : ""}{" "}
                            <br></br>
                            <small>
                              {" "}
                              {interviewState && interviewState.coordinator
                                ? interviewState.coordinator.email
                                : ""}{" "}
                            </small>
                            <br></br>
                            <small>
                              {" "}
                              {interviewState && interviewState.coordinator
                                ? interviewState.coordinator.mobile_number
                                : ""}
                            </small>
                          </p>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-2 live-interviewer-details-col">
                          {/* {interviewState &&
                            interviewState.sample_feedback_sheet ? (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip>Feedback Sheet</Tooltip>}
                            >
                              <Button
                                variant="light"
                                onClick={() =>
                                  window.open(
                                    `${process.env.REACT_APP_BUCKET_URL}${interviewState.sample_feedback_sheet}`,
                                    "_blank"
                                  )
                                }
                                className="full-width sample-feedback-button"
                              >
                                <AiOutlineFile size={18} />
                                <span>
                                  {new URL(
                                    `${process.env.REACT_APP_BUCKET_URL}${interviewState.sample_feedback_sheet}`
                                  ).pathname
                                    .split("/")
                                    .pop()
                                    .replaceAll("%20", " ")}
                                </span>
                              </Button>
                            </OverlayTrigger>
                          ) : (
                            ""
                          )} */}
                          <p className="live-interviewer-details-card-title">
                            Scheduled On
                          </p>
                          <p className="live-interviewer-details-card-title-samll">
                            {interviewState
                              ? commonDateFormat(interviewState.scheduled_on)
                              : ""}
                          </p>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3 live-interviewer-details-col my-2 my-md-2 my-lg-0">
                          <span className="google-meet-id-span">
                            {interviewState && interviewState.google_meet_id ? (
                              <p className="google-meet-id-p">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip>Google Meeting Link</Tooltip>
                                  }
                                >
                                  <Button
                                    className="google-meet-link-button w-100"
                                    variant="light"
                                    size="sm"
                                    onClick={() =>
                                      window.open(
                                        interviewState
                                          ? interviewState.google_meet_id
                                          : "",
                                        "_blank"
                                      )
                                    }
                                  >
                                    <span>{interviewState.google_meet_id}</span>
                                  </Button>
                                </OverlayTrigger>
                              </p>
                            ) : (
                              <InputGroup className="mb-3">
                                <Form.Control
                                  placeholder="Google meet id"
                                  value={interviewDetail.google_meet_id}
                                  onChange={(e) => {
                                    setInterviewDetail({
                                      ...interviewDetail,
                                      google_meet_id: e.target.value,
                                    });
                                  }}
                                />
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => updateCandidateProfile()}
                                >
                                  Add
                                </Button>
                              </InputGroup>
                            )}
                          </span>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2 live-interviewer-details-col my-2 my-md-2 my-lg-0">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip>Join Conference</Tooltip>}
                          >
                            <Button
                              className="google-meet-link-button w-100"
                              variant="success"
                              size="sm"
                              onClick={() =>
                                window.open(
                                  interviewState
                                    ? interviewState.google_meet_id
                                    : "",
                                  "_blank"
                                )
                              }
                            >
                              <BsGoogle size={14} />
                              <span>Join Conference</span>
                            </Button>
                          </OverlayTrigger>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 live-interviewer-details-col my-2 my-md-2 my-lg-0">
                          <Form.Select
                            className="interviewStatus w-100"
                            aria-label="Choose"
                            id="interviewStatus"
                            name="interviewStatus"
                            placeholder="All"
                            onChange={(e) => {
                              setInterviewDetail({
                                ...interviewDetail,
                                incomplete_interview: e.target.value,
                              });
                            }}
                            value={interviewDetail.incomplete_interview}
                            disabled={interviewDetail.final_status === INTERVIEW_FINAL_STATUS_SELECTED}
                          >
                            <option value="">Select Incomplete Reason</option>
                            <option value={BANDWIDTH_ISSUE_CANDIDATE_END}>
                              Bandwidth issue (Candidate end)
                            </option>
                            <option value={BANDWIDTH_ISSUE_INTERVIEWER_END}>
                              Bandwidth issue (Interviewer end)
                            </option>
                            <option value={HARDWARE_ISSUE_CANDIDATE_END}>
                              Hardware issue (Candidate end)
                            </option>
                            <option value={HARDWARE_ISSUE_INTERVIEWER_END}>
                              Hardware issue (Interviewer end)
                            </option>
                            <option value={PROXY}>Proxy Candidate</option>
                            <option value={NO_SHOW_BY_INTERVIWER}>
                              No Show by Interviewer
                            </option>
                            <option value={NO_SHOW_BY_CANDIDATE}>
                              No Show by Candidate
                            </option>
                          </Form.Select>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2 live-interviewer-details-col">
                          <Button
                            className="live-interviewer-details-button w-100"
                            size="sm"
                            disabled={isNotEditable()}
                            onClick={() => {
                              if (!interviewState?.candidate_pic) {
                                toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: "Please upload candidate's profile picture to proceed with the submission.",
                                  life: 3000,
                                });
                                return;
                              }
                              if (
                                interviewDetail.incomplete_interview !==
                                null &&
                                interviewDetail.incomplete_interview !== ""
                              ) {
                                const feedbackMessage =
                                  "Feedback submitted successfully";
                                updateCandidateProfile(feedbackMessage);
                              } else {
                                if (
                                  interviewState &&
                                  interviewState.job
                                    .custom_feedback_sheet_file
                                ) {
                                  if (!interviewDetail.feedback_sheet) {
                                    toast.current.show({
                                      severity: "error",
                                      summary: "Error",
                                      detail:
                                        "Please upload candidate's feedback sheet to proceed with the submission.",
                                      life: 3000,
                                    });
                                  } else {
                                    const feedbackMessage =
                                      interviewDetail.is_feedback_given
                                        ? "Feedback updated successfully"
                                        : "Feedback submitted successfully";
                                    interviewDetail.is_feedback_given = true;
                                    updateCandidateProfile(feedbackMessage);
                                  }
                                } else {
                                  if (checkFeedbackGiven()) {
                                    const feedbackMessage =
                                      interviewDetail.is_feedback_given
                                        ? "Feedback updated successfully"
                                        : "Feedback submitted successfully";
                                    interviewDetail.is_feedback_given = true;
                                    updateCandidateProfile(feedbackMessage);
                                  }
                                }
                              }
                            }}
                          >
                            Submit
                            <VscSend size={16} className="mx-2" />
                          </Button>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  <Tab.Content className="my-3">
                    <Tab.Pane eventKey="liveinterview">
                      <Card className="live-interviewer-sills-card mt-2">
                        <Card.Body>
                          <Tabs defaultActiveKey="primaryskills" justify>
                            <Tab
                              eventKey="primaryskills"
                              title="Primary skills"
                            >
                              <div className="row tabHeight">
                                <div className="col-12 p-5">
                                  {interviewState
                                    ? _.map(
                                      interviewState.job.primary_skill,
                                      (skill, index) => {
                                        const feedback = interviewDetail.primary_skill_feedback[index] || { review: "", rating: 0 };
                                        return (
                                          <p key={"primary_skill_" + index}>
                                            {skill}
                                          </p>
                                        );
                                      }
                                    )
                                    : ""}
                                </div>
                              </div>
                            </Tab>
                            <Tab
                              eventKey="secondaryskills"
                              title="Secondary skills"
                            >
                              <div className="row tabHeight">
                                <div className="col-12 p-5">
                                  {interviewState
                                    ? _.map(
                                      interviewState.job.secondary_skill,
                                      (skill, index) => {
                                        const feedback = interviewDetail.secondary_skill_feedback[index] || { review: "", rating: 0 };
                                        return (
                                          <p key={"secondary_skill_" + index}>
                                            {skill}
                                          </p>
                                        );
                                      }
                                    )
                                    : ""}
                                </div>
                              </div>
                            </Tab>
                            <Tab
                              eventKey="additionalskills"
                              title="Additional skills"
                            >
                              <div className="row tabHeight">
                                <div className="col-12 p-5">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: interviewState
                                        ? interviewState.job
                                          .good_to_have_skills_textarea
                                        : "",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </Tab>
                            <Tab
                              eventKey="interviewquestions"
                              title="Interview questions"
                            >
                              <div className="row tabHeight">
                                <div className="col-12 p-5">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: interviewState
                                        ? interviewState.job
                                          .mandatory_interview_questions_textarea
                                        : "",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </Tab>
                            <Tab
                              eventKey="codingquestions"
                              title="Coding questions"
                            >
                              <div className="row tabHeight">
                                <div className="col-12 p-5">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: interviewState
                                        ? interviewState.job
                                          .mandatory_coding_questions_textarea
                                        : "",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </Tab>
                          </Tabs>
                        </Card.Body>
                      </Card>
                      <div className="row live-interviewer-other-details mt-3">
                        <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-5">
                          <Card>
                            <Card.Body>
                              <div className="row">
                                <div className="col-12">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="live-interviewer-other-details-code-test-title">
                                      Coding Test
                                    </p>
                                    <Form.Check
                                      type="switch"
                                      className="coding-test-switch"
                                      checked={
                                        interviewState && interviewState.job
                                          ? interviewState.job
                                            .is_coding_test_mandatory
                                          : false
                                      }
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <p className="live-interviewer-other-details-code-test-hint text-danger">
                                    Hint : Please ask the candidate to write
                                    using the link sent to mail
                                  </p>
                                </div>
                                <div className="col-12 tab-adjust_2">
                                  <Tabs
                                    defaultActiveKey="uploadscreenshot"
                                    justify
                                  >
                                    <Tab
                                      eventKey="codebycandidate"
                                      title="Code by candidate"
                                    >
                                      <div className="row">
                                        <div className="col-12 p-5">
                                          {interviewState &&
                                            interviewState.code_by_candidate && (
                                              <SyntaxHighlighter
                                                language="java"
                                                style={solarizedlight}
                                              >
                                                {interviewState
                                                  ? interviewState.code_by_candidate
                                                  : ""}
                                              </SyntaxHighlighter>
                                            )}
                                        </div>
                                      </div>
                                    </Tab>
                                    <Tab
                                      eventKey="codingquestion"
                                      title="Coding question"
                                    >
                                      <div className="row">
                                        <div className="col-12 p-5">
                                          <CKEditor
                                            disabled={isNotEditable()}
                                            config={{
                                              placeholder:
                                                "Provide coding questions to candidate*",
                                            }}
                                            editor={ClassicEditor}
                                            data={
                                              interviewState
                                                ? interviewState.coding_questions
                                                : ""
                                            }
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              interviewDetail.coding_questions =
                                                data;
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Tab>
                                    <Tab
                                      eventKey="uploadscreenshot"
                                      title="Upload Screenshot"
                                    >
                                      <div className="row">
                                        {interviewDetail &&
                                          interviewDetail.code_of_screenshot && (
                                            <div className="col-12 px-4 pt-5">
                                              <ul key="code_of_screenshot">
                                                {interviewDetail.code_of_screenshot.map(
                                                  (item, docIndex) => {
                                                    return (
                                                      <li
                                                        key={
                                                          "code_of_screenshot_" +
                                                          docIndex
                                                        }
                                                      >
                                                        <div>
                                                          <a
                                                            target="_blank"
                                                            href={`${process.env.REACT_APP_BUCKET_URL}${item}`}
                                                          >
                                                            {new URL(
                                                              `${process.env.REACT_APP_BUCKET_URL}${item}`
                                                            ).pathname
                                                              .split("/")
                                                              .pop()
                                                              .replaceAll(
                                                                "%20",
                                                                " "
                                                              )}
                                                          </a>
                                                          &nbsp;&nbsp;
                                                          {
                                                            !isNotEditable() && (
                                                              <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                  <Tooltip>
                                                                    Remove
                                                                    Screenshots
                                                                  </Tooltip>
                                                                }
                                                              >
                                                                <i
                                                                  onClick={() => {
                                                                    const codeOfScreenshot =
                                                                      interviewDetail.code_of_screenshot.filter(
                                                                        (
                                                                          item,
                                                                          index
                                                                        ) =>
                                                                          index !==
                                                                          docIndex
                                                                      );
                                                                    interviewDetail.code_of_screenshot =
                                                                      codeOfScreenshot;
                                                                    updateCandidateProfile(
                                                                      "Screenshot removed successfully",
                                                                      true
                                                                    );
                                                                  }}
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    fontSize:
                                                                      "1rem",
                                                                  }}
                                                                  className="pi pi-times"
                                                                ></i>
                                                              </OverlayTrigger>
                                                            )
                                                          }

                                                        </div>
                                                      </li>
                                                    );
                                                  }
                                                )}
                                              </ul>
                                            </div>
                                          )}
                                        <div className="col-12 px-5 py-3">
                                          <div className="row live-interviewer-other-details-code-test-upload-screenshot">
                                            <div className="col-12 p-5 text-center">
                                              <Form.Control
                                                disabled={isNotEditable()}
                                                onChange={(e) => {
                                                  const file = e.target.files;
                                                  if (
                                                    e.target.files &&
                                                    e.target.files.length > 0 &&
                                                    file
                                                  ) {
                                                    if (
                                                      !file[0].type.startsWith(
                                                        "image/"
                                                      )
                                                    ) {
                                                      toast.current.show({
                                                        severity: "error",
                                                        summary: "Error",
                                                        detail:
                                                          "Please upload only images",
                                                        life: 3000,
                                                      });
                                                    } else {
                                                      handleFileChange(
                                                        e,
                                                        "code_of_screenshot"
                                                      );
                                                      const codeOfScreenshotFileInput =
                                                        document.getElementById(
                                                          "codeOfScreenshotFileInput"
                                                        );
                                                      if (
                                                        codeOfScreenshotFileInput
                                                      ) {
                                                        codeOfScreenshotFileInput.value =
                                                          null;
                                                      }
                                                    }
                                                  }
                                                }}
                                                id="codeOfScreenshotFileInput"
                                                type="file"
                                                accept="image/*"
                                                className="w-50 m-auto"
                                              />
                                              <p className="live-interviewer-other-details-code-test-upload-screenshot-hint">
                                                Upload candidate screenshot and coding test screenshot
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Tab>
                                  </Tabs>
                                </div>
                              </div>
                              <div>
                                <Button
                                  disabled={isNotEditable()}
                                  className="live-interviewer-details-button"
                                  onClick={() => {
                                    updateCandidateProfile("Candidate detail Saved");
                                  }}
                                >
                                  Save
                                  <VscSend size={16} className="mx-2" />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7">
                          <Card>
                            <Card.Body>
                              <div className="row">
                                <div className="col-12 tab-adjust">
                                  <Tabs
                                    variant="underline"
                                    defaultActiveKey={
                                      interviewState &&
                                        interviewState.job
                                          .custom_feedback_sheet_file
                                        ? "overallFeedback"
                                        : "primarySkillFeedback"
                                    }
                                    justify
                                    onSelect={(value) => {
                                      setActiveTabKey(value);
                                    }}
                                  >
                                    {interviewState &&
                                      !interviewState.job
                                        .custom_feedback_sheet_file && (
                                        <Tab
                                          eventKey="primarySkillFeedback"
                                          title="Primary Skill"
                                        >
                                          <div className="row">
                                            {interviewState?.job?.primary_skill?.map((skill, index) => {
                                              // Get the current feedback, defaulting to empty if not present
                                              const feedback = interviewDetail.primary_skill_feedback[index] || { review: "", rating: 0 };

                                              return (
                                                <React.Fragment key={`primary_skill_${index}`}>
                                                  <div className="col-5 col-md-6 col-lg-6 my-3">
                                                    <Button variant="outline-dark">
                                                      {skill}
                                                    </Button>
                                                  </div>
                                                  <div className="col-7 col-md-6 col-lg-6 my-3 text-end text-md-end text-lg-end">
                                                    <StarRating
                                                      totalStars={5}
                                                      filledStars={feedback.rating || 0}
                                                      onRatingChange={(newRating) => {
                                                        // Update only the rating for this specific skill
                                                        setInterviewDetail(prev => {
                                                          const newPrimaryFeedback = [...(prev.primary_skill_feedback || [])];
                                                          newPrimaryFeedback[index] = {
                                                            ...newPrimaryFeedback[index],
                                                            rating: newRating
                                                          };
                                                          return {
                                                            ...prev,
                                                            primary_skill_feedback: newPrimaryFeedback
                                                          };
                                                        });
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-12">
                                                    <CKEditor
                                                      disabled={isNotEditable()}
                                                      config={{
                                                        placeholder: "Provide primary skill feedback*",
                                                        height: '200px',
                                                        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                                      }}
                                                      editor={ClassicEditor}
                                                      data={feedback.review || ""}
                                                      onChange={(event, editor) => {
                                                        //Changed
                                                        let data = editor.getData();

                                                        data = enforceMaxLength(
                                                        data,
                                                        SKILL_MAX_LENGTH
                                                      );

                                                        // Update only the review for this specific skill
                                                        setInterviewDetail(prev => {
                                                          const newPrimaryFeedback = [...(prev.primary_skill_feedback || [])];
                                                          newPrimaryFeedback[index] = {
                                                            ...newPrimaryFeedback[index],
                                                            review: data
                                                          };
                                                          return {
                                                            ...prev,
                                                            primary_skill_feedback: newPrimaryFeedback
                                                          };
                                                        });
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="char-count mt-2">
                                                    {getMinLengthRemaining(feedback.review, primaryMin) > 0 && (
                                                      <div className="char-count mt-2">
                                                        Characters remaining: {getMinLengthRemaining(feedback.review, primaryMin)}
                                                      </div>
                                                    )}
                                                  </div>
                                                </React.Fragment>
                                              );
                                            })}
                                          </div>
                                        </Tab>
                                      )}
                                    {interviewState &&
                                      !interviewState.job
                                        .custom_feedback_sheet_file && (
                                        <Tab
                                          eventKey="secondarySkillFeedback"
                                          title="Secondary Skill"
                                        >
                                          <div className="row">
                                            {interviewState?.job?.secondary_skill?.map((skill, index) => {
                                              // Get the current feedback, defaulting to empty if not present
                                              const feedback = interviewDetail.secondary_skill_feedback[index] || { review: "", rating: 0 };

                                              return (
                                                <React.Fragment key={`secondary_skill_${index}`}>
                                                  <div className="col-5 col-md-6 col-lg-6 my-3">
                                                    <Button variant="outline-dark">
                                                      {skill}
                                                    </Button>
                                                  </div>
                                                  <div className="col-7 col-md-6 col-lg-6 my-3 text-end text-md-end text-lg-end">
                                                    <StarRating
                                                      totalStars={5}
                                                      filledStars={feedback.rating || 0}
                                                      onRatingChange={(newRating) => {
                                                        // Update only the rating for this specific skill
                                                        setInterviewDetail(prev => {
                                                          const newSecondaryFeedback = [...(prev.secondary_skill_feedback || [])];
                                                          newSecondaryFeedback[index] = {
                                                            ...newSecondaryFeedback[index],
                                                            rating: newRating
                                                          };
                                                          return {
                                                            ...prev,
                                                            secondary_skill_feedback: newSecondaryFeedback
                                                          };
                                                        });
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col-12">
                                                    <CKEditor
                                                      disabled={isNotEditable()}
                                                      config={{
                                                        placeholder: "Provide secondary skill feedback*",
                                                        height: '200px',
                                                        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                                      }}
                                                      editor={ClassicEditor}
                                                      data={feedback.review || ""}
                                                      onChange={(event, editor) => {
                                                        //Changed
                                                        let data = editor.getData();

                                                        data = enforceMaxLength(
                                                        data,
                                                        SKILL_MAX_LENGTH
                                                      );
                                                        // Update only the review for this specific skill
                                                        setInterviewDetail(prev => {
                                                          const newSecondaryFeedback = [...(prev.secondary_skill_feedback || [])];
                                                          newSecondaryFeedback[index] = {
                                                            ...newSecondaryFeedback[index],
                                                            review: data
                                                          };
                                                          return {
                                                            ...prev,
                                                            secondary_skill_feedback: newSecondaryFeedback
                                                          };
                                                        });
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="char-count mt-2">
                                                    {getMinLengthRemaining(feedback.review, secondaryMin) > 0 && (
                                                      <div className="char-count mt-2">
                                                        Characters remaining: {getMinLengthRemaining(feedback.review, secondaryMin)}
                                                      </div>
                                                    )}
                                                  </div>
                                                </React.Fragment>
                                              );
                                            })}
                                          </div>
                                        </Tab>
                                      )}
                                    {interviewState &&
                                      !interviewState.job
                                        .custom_feedback_sheet_file && (
                                        <Tab
                                          eventKey="goodToHaveSkillFeedback"
                                          title="Good to have skills"
                                        >
                                          <div className="row">
                                            <div className="col-6 my-3">
                                              {/* <Button variant="primary">
                                                                                                        {"Rating"}
                                                                                                    </Button> */}
                                            </div>
                                            <div
                                              className="col-6"
                                              style={{ textAlign: "right" }}
                                            >
                                              <StarRating
                                                totalStars={5}
                                                filledStars={
                                                  interviewDetail &&
                                                    interviewDetail.good_to_have_skill_feedback_rating
                                                    ? interviewDetail.good_to_have_skill_feedback_rating
                                                    : 0
                                                }
                                                onRatingChange={(newRating) => {
                                                  interviewDetail.good_to_have_skill_feedback_rating =
                                                    newRating;
                                                  setInterviewDetail({
                                                    ...interviewDetail,
                                                  });
                                                  updateCandidateProfile(
                                                    "",
                                                    false
                                                  );
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="row">
                                            <div className="col-12 my-3">
                                              <CKEditor
                                                disabled={isNotEditable()}
                                                config={{
                                                  placeholder:
                                                    "Provide good to have skills feedback*",
                                                  height: '200px',
                                                  toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                                }}
                                                editor={ClassicEditor}
                                                data={
                                                        interviewDetail.good_to_have_skill_feedback || ""
                                                   }
                                                onChange={(event, editor) => handleEditorChange(event, editor, 'good_to_have_skill_feedback')}
                                              />
                                            </div>
                                          </div>
                                          <div className="char-count mt-2">
                                            {getMinLengthRemaining(interviewDetail.good_to_have_skill_feedback, 50) > 0 && (
                                              <div className="char-count mt-2">
                                                Characters remaining: {getMinLengthRemaining(interviewDetail.good_to_have_skill_feedback, 50)}
                                              </div>
                                            )}
                                          </div>
                                        </Tab>
                                      )}
                                    {interviewState &&
                                      !interviewState.job
                                        .custom_feedback_sheet_file && (
                                        <Tab
                                          eventKey="codingSkillFeedback"
                                          title="Coding skills"
                                        >
                                          <div className="row">
                                            <div className="col-6 my-3">
                                            </div>
                                            <div
                                              className="col-6 my-3"
                                              style={{
                                                textAlign: "right",
                                              }}
                                            >
                                              <StarRating
                                                totalStars={5}
                                                filledStars={
                                                  interviewDetail &&
                                                    interviewDetail.coding_skill_feedback_rating
                                                    ? interviewDetail.coding_skill_feedback_rating
                                                    : 0
                                                }
                                                onRatingChange={(newRating) => {
                                                  interviewDetail.coding_skill_feedback_rating =
                                                    parseInt(newRating);
                                                  setInterviewDetail({
                                                    ...interviewDetail,
                                                  });
                                                  updateCandidateProfile(
                                                    "",
                                                    false
                                                  );
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <div className="row">
                                            <div className="col-12 my-3">
                                              <CKEditor
                                                disabled={isNotEditable()}
                                                config={{
                                                  placeholder:
                                                    "Provide coding skills feedback*",
                                                  height: '200px',
                                                  toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                                }}
                                                editor={ClassicEditor}
                                                data={
                                                    interviewDetail.coding_skill_feedback || ""
                                                  }
                                                onChange={(event, editor) => handleEditorChange(event, editor, 'coding_skill_feedback')}
                                              />
                                            </div>
                                          </div>
                                          <div className="char-count mt-2">
                                            {getMinLengthRemaining(interviewDetail.coding_skill_feedback, 50) > 0 &&
                                              `Characters remaining: ${getMinLengthRemaining(interviewDetail.coding_skill_feedback, 50)}`}
                                          </div>
                                        </Tab>
                                      )}
                                    < Tab
                                      eventKey="ProfessionalSkillFeedback"
                                      title="Professional skills"
                                    >
                                      {interviewState && (interviewState.job.custom_feedback_sheet_file !== "" || !interviewState.job.custom_feedback_sheet_file) &&
                                        Object.entries(interviewState.professional_skill).map(([key, skillItem], index) => (
                                          <div key={key}>
                                            <div className="row">
                                              <div className="col-12 my-2">
                                                <Form.Check
                                                  inline
                                                  label={skillItem.label}
                                                  checked={interviewDetail.professional_skill[key].enable}
                                                  onChange={(e) => handleProfessionalSkillCheckbox(e, key)}
                                                  type="checkbox"
                                                />
                                              </div>
                                            </div>

                                            {interviewDetail.professional_skill[key].enable && (
                                              <>
                                                <div className="row">
                                                  <div className="col-6 my-3">
                                                    <Button variant="outline-dark">
                                                      {skillItem.label}
                                                    </Button>
                                                  </div>
                                                  <div
                                                    className="col-6 my-3 text-end"
                                                  >
                                                    <StarRating
                                                      totalStars={5}
                                                      filledStars={interviewDetail.professional_skill[key].rating || 0}
                                                      onRatingChange={(newRating) => {
                                                        const updatedProfessionalSkill = {
                                                          ...interviewDetail.professional_skill,
                                                          [key]: {
                                                            ...interviewDetail.professional_skill[key],
                                                            rating: newRating
                                                          }
                                                        };

                                                        setInterviewDetail({
                                                          ...interviewDetail,
                                                          professional_skill: updatedProfessionalSkill
                                                        });

                                                        updateCandidateProfile("", false);
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="row">
                                                  <div className="col-12 my-3">
                                                    <CKEditor
                                                      disabled={isNotEditable()}
                                                      config={{
                                                        placeholder: `Provide feedback for ${skillItem.label}*`,
                                                        height: '200px',
                                                        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                                      }}
                                                      editor={ClassicEditor}
                                                      data={interviewDetail.professional_skill[key].feedback}
                                                      onChange={(event, editor) => {
                                                        //Changed
                                                        let  data = editor.getData();

                                                        data = enforceMaxLength(
                                                        data,
                                                        SKILL_MAX_LENGTH
                                                      );
                                                        // Remove all max character limit logic for professional skills feedback
                                                        const updatedProfessionalSkill = {
                                                          ...interviewDetail.professional_skill,
                                                          [key]: {
                                                            ...interviewDetail.professional_skill[key],
                                                            feedback: data
                                                          }
                                                        };
                                                        setInterviewDetail({
                                                          ...interviewDetail,
                                                          professional_skill: updatedProfessionalSkill
                                                        });
                                                        updateCandidateProfile("", false);
                                                      }}
                                                    />
                                                    <div className="char-count mt-2">
                                                      {getMinLengthRemaining(interviewDetail.professional_skill[key].feedback, 50) > 0 &&
                                                        `Characters remaining: ${getMinLengthRemaining(interviewDetail.professional_skill[key].feedback, 50)}`}
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        ))
                                      }
                                    </Tab>
                                    <Tab
                                      eventKey="overallFeedback"
                                      title="Overall Feedback"
                                    >
                                      <div className="row mx-3 my-3">
                                        <div className="col-12 col-md-4 col-lg-3 text-center">
                                          <StarRating
                                            totalStars={5}
                                            filledStars={
                                              interviewDetail.overall_rating
                                            }
                                            onRatingChange={(newRating) => {
                                              setInterviewDetail({
                                                ...interviewDetail,
                                                overall_rating: newRating,
                                              });
                                              updateCandidateProfile("", false);
                                            }}
                                          />
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-3 text-center my-2">
                                          <Form.Select
                                            disabled={isNotEditable()}
                                            aria-label="Rating"
                                            onChange={handleFinalStatusChange}
                                            value={interviewDetail.final_status}
                                          >
                                            <option>Final Status</option>
                                            <option value={INTERVIEW_FINAL_STATUS_SELECTED}>
                                              {"Selected"}
                                            </option>
                                            <option value={INTERVIEW_FINAL_STATUS_REJECTED}>
                                              {"Rejected"}
                                            </option>
                                          </Form.Select>
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-6 text-center my-2">
                                          {interviewState &&
                                            interviewState.job
                                              .custom_feedback_sheet_file ? (
                                            <Button
                                              onClick={() =>
                                                handleDownload(
                                                  interviewState
                                                    ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.job
                                                      .custom_feedback_sheet_file}`
                                                    : ""
                                                )
                                              }
                                            >
                                              Download custom feedback sheet{" "}
                                              <RiDownload2Fill size={20} />
                                            </Button>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      {interviewState &&
                                        interviewState.job
                                          .custom_feedback_sheet_file && (
                                          <div className="row">
                                            {interviewState &&
                                              interviewState.feedback_sheet && (
                                                <div className="col-12 px-3">
                                                  <ul>
                                                    <li>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                          <Tooltip>
                                                            Feedback Sheet
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <a
                                                          target="_blank"
                                                          href={
                                                            `${process.env.REACT_APP_BUCKET_URL}${interviewState.feedback_sheet}`
                                                          }
                                                        >
                                                          {new URL(
                                                            `${process.env.REACT_APP_BUCKET_URL}${interviewState.feedback_sheet}`
                                                          ).pathname
                                                            .split("/")
                                                            .pop()
                                                            .replaceAll(
                                                              "%20",
                                                              " "
                                                            )}
                                                        </a>
                                                      </OverlayTrigger>
                                                    </li>
                                                  </ul>
                                                </div>
                                              )}
                                            <div className="col-12 px-5 py-3">
                                              <div className="row live-interviewer-other-details-code-test-upload-screenshot">
                                                <div className="col-12 p-5 text-center">
                                                  <Form.Control
                                                    ref={feedbackSheetInputRef}
                                                    onChange={(e) => {
                                                      setHasSelectedFile(e.target.files && e.target.files.length > 0);
                                                      handleFileChange(
                                                        e,
                                                        "feedback_sheet"
                                                      );
                                                    }}
                                                    type="file"
                                                    className="w-50 m-auto"
                                                  />
                                                  {hasSelectedFile && interviewDetail.feedback_sheet && interviewDetail.feedback_sheet !== "" && (
                                                    <div className="mt-2">
                                                      <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={async () => {
                                                          const data = { old_path: interviewDetail.feedback_sheet }
                                                          await fetch(`${API_URL}/api/deleteFiles`, {
                                                            method: 'POST',
                                                            body: data
                                                          })
                                                          await setInterviewDetail({
                                                            ...interviewDetail,
                                                            feedback_sheet: ""
                                                          });
                                                          if (feedbackSheetInputRef.current) {
                                                            feedbackSheetInputRef.current.value = "";
                                                          }
                                                          setHasSelectedFile(false);
                                                        }}
                                                      >
                                                        Delete File
                                                      </Button>
                                                    </div>
                                                  )}
                                                  <p className="live-interviewer-other-details-code-test-upload-screenshot-hint">
                                                    Upload candidate's feedback sheet here
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      {interviewState &&
                                        !interviewState.job
                                          .custom_feedback_sheet_file && (
                                          <>
                                            <div className="row">
                                              <div className="col-12 p-5">
                                                <CKEditor
                                                  disabled={isNotEditable()}
                                                  config={{
                                                    placeholder:
                                                      "Provide final recommendation*",
                                                    height: '200px',
                                                    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                                    clipboard: { handleFiles: false }
                                                  }}
                                                  editor={ClassicEditor}
                                                  data={interviewDetail.final_recommendation || ""}
                                                  onChange={(event, editor) => handleEditorChange(event, editor, 'final_recommendation')}
                                                />
                                              </div>
                                            </div>
                                            <div className="char-count mt-2">
                                              {getMinLengthRemaining(interviewDetail.final_recommendation, FINAL_FEEDBACK_MIN_LENGTH) > 0 && (
                                                <div className="char-count mt-2">
                                                  Characters remaining: {getMinLengthRemaining(interviewDetail.final_recommendation, FINAL_FEEDBACK_MIN_LENGTH)}
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        )}
                                    </Tab>
                                  </Tabs>
                                </div>
                              </div>
                              {/* <div>
                                                                    <Button className="live-interviewer-details-button"
                                                                        onClick={() => {
                                                                            updateCandidateProfile();
                                                                        }}
                                                                    >Save<VscSend size={22} className="mx-2" /></Button>
                                                                </div> */}
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="resume">
                      <Card>
                        <Card.Body>
                          <div className="row">
                            <div className="col-12 text-center">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Download Resume</Tooltip>}
                              >
                                <a
                                  href="javascript:void(0)"
                                  className="live-interviewer-resume-download"
                                  onClick={() => {
                                    handleDownload(
                                      interviewState
                                        ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.resume}`
                                        : ""
                                    );
                                  }}
                                >
                                  <ImDownload2 size={24} />
                                  <span>Download</span>
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Print Resume</Tooltip>}
                              >
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => {
                                    printPDF(
                                      interviewState
                                        ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.resume}`
                                        : ""
                                    );
                                  }}
                                  className="live-interviewer-resume-download mx-5"
                                >
                                  <BiSolidPrinter size={24} />
                                  <span>Print</span>
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip>Save as a copy Resume</Tooltip>
                                }
                              >
                                <a
                                  onClick={() => {
                                    handleDownload(
                                      interviewState
                                        ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.resume}`
                                        : ""
                                    );
                                  }}
                                  href="javascript:void(0)"
                                  className="live-interviewer-resume-download"
                                >
                                  <FaCloudUploadAlt size={24} />
                                  <span>Save as a copy</span>
                                </a>
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 text-center">
                              {interviewState ? (
                                interviewState.resume.includes(".doc") ? (
                                  <iframe
                                    key="iframe-doc"
                                    style={{
                                      width: "100%",
                                      height: "80vh",
                                    }}
                                    src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_BUCKET_URL}${interviewState.resume}`}&embedded=true`}
                                  ></iframe>
                                ) : (
                                  // <EmbedPDF>
                                  //   <a href={`${process.env.REACT_APP_BUCKET_URL}${interviewState.resume}`}>
                                  //     Click here to open view
                                  //   </a>
                                  // </EmbedPDF>
                                  <iframe title="Resume" key="iframe-doc" style={{
                                    width: '100%',
                                    height: '100vh'
                                  }} src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_BUCKET_URL}${interviewState.resume}`}&embedded=true`}></iframe>
                                )
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey="jobresponsibilities">
                      <Card>
                        <Card.Body className="p-5">
                          <div className="row">
                            <div className="col-12">
                              <b>Job Responsibilities :</b>
                              <div
                                className="mt-3"
                                dangerouslySetInnerHTML={{
                                  __html: interviewState
                                    ? interviewState.job.job_title
                                    : "",
                                }}
                              ></div>
                            </div>
                            <div className="col-12">
                              <b>Description :</b>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: interviewState
                                    ? interviewState.job.job_discription
                                    : "",
                                }}
                              ></div>
                            </div>
                            <div className="col-12">
                              <br></br>
                              {interviewState ? (
                                interviewState.job.upload_jd.includes(
                                  ".doc"
                                ) ? (
                                  <iframe
                                    key="iframe-doc"
                                    style={{
                                      width: "100%",
                                      height: "80vh",
                                    }}
                                    src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_BUCKET_URL}${interviewState.job.upload_jd}`}&embedded=true`}
                                  ></iframe>
                                ) : (
                                  // <EmbedPDF>
                                  //   <a href={`${process.env.REACT_APP_BUCKET_URL}${interviewState.job.upload_jd}`}>
                                  //     Click here to open
                                  //   </a>
                                  // </EmbedPDF>
                                  <iframe title="Resume" key="iframe-doc" style={{
                                    width: '100%',
                                    height: '100%'
                                  }} src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_BUCKET_URL}${interviewState.upload_jd}`}&embedded=true`}></iframe>
                                )
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey="aboutcompany">
                      <Card>
                        <Card.Body className="p-5">
                          <div className="row">
                            {interviewState.company.profile_photo !== "" &&
                              <div className="col-6">
                                <img
                                  src={
                                    interviewState && interviewState.company
                                      ? `${process.env.REACT_APP_BUCKET_URL}${interviewState.company.profile_image}`
                                      : ""
                                  }
                                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                                />
                              </div>
                            }
                            {/* <div className="col-6 text-end">
                                                                URL: <a href={jobDetails.company_url} target="_blank">{jobDetails.company_url}</a>
                                                            </div> */}
                            <div className="col-12 mt-4">
                              <b>About Company :</b>
                              <p
                                className="mt-3"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    interviewState && interviewState.company
                                      ? interviewState.company
                                        .company_description
                                      : "",
                                }}
                              ></p>
                            </div>
                            <div className="col-12 mt-4">
                              <div className="row">
                                {/* <div id="jdoodle-container" data-pym-src='https://www.jdoodle.com/plugin' data-language="php" data-version-index="4">
                                                                    </div> */}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              )}
            </div>
          </Tab.Container>
        </div>
      </div >
    </div >
  );
};
export default LiveInterviewerScreen;
